import type { AssistantConversationSummary } from '@stores/assistantStore'
import dayjs, { Dayjs } from 'dayjs'

export interface ConversationGroup {
  label: string
  items: AssistantConversationSummary[]
}

/** History sections, newest first: Today, Yesterday, Previous 7 days, Older. */
export const groupConversations = (
  conversations: AssistantConversationSummary[],
  now: Dayjs = dayjs()
): ConversationGroup[] => {
  const today = now.startOf('day')
  const groups: ConversationGroup[] = [
    { label: 'Today', items: [] },
    { label: 'Yesterday', items: [] },
    { label: 'Previous 7 days', items: [] },
    { label: 'Older', items: [] },
  ]

  const sorted = [...conversations].sort(
    (a, b) =>
      dayjs(b.lastMessageAt).valueOf() - dayjs(a.lastMessageAt).valueOf()
  )
  for (const conversation of sorted) {
    const day = dayjs(conversation.lastMessageAt).startOf('day')
    const age = today.diff(day, 'day')
    const index = age <= 0 ? 0 : age === 1 ? 1 : age <= 7 ? 2 : 3
    groups[index].items.push(conversation)
  }
  return groups.filter(g => g.items.length > 0)
}

/** Time for a history row: "14:05" today and yesterday, otherwise the date. */
export const conversationTime = (
  lastMessageAt: string,
  dateFormat = 'DD/MM/YYYY',
  now: Dayjs = dayjs()
) => {
  const at = dayjs(lastMessageAt)
  return now.startOf('day').diff(at.startOf('day'), 'day') <= 1
    ? at.format('HH:mm')
    : at.format(dateFormat)
}
